import type { ReactNode } from "react";
import Button from "@/components/Button";

type EmailPreviewModalActionsProps = {
  onPreview: () => void;
  previewDisabled?: boolean;
  showPreview?: boolean;
  children: ReactNode;
};

export default function EmailPreviewModalActions({
  onPreview,
  previewDisabled,
  showPreview = true,
  children
}: EmailPreviewModalActionsProps) {
  return (
    <div className="flex w-full min-w-0 flex-wrap items-center gap-2">
      {showPreview ? (
        <Button variant="text" icon="mail" onClick={onPreview} disabled={previewDisabled} testId="preview-email-button">
          Preview Email
        </Button>
      ) : null}
      <div className="ml-auto flex flex-wrap justify-end gap-2">{children}</div>
    </div>
  );
}
